// @core/api/endpoints/project/delete_saved_view.ts
// Auto-generated by corebuilder. DO NOT EDIT.

import { getApiClient, type RequestOptions } from '../../client';

const BASE_PATH = '/project';

/**
 * Delete saved view
 * Deletes a saved view. Only the creator or a project admin can delete a view.
 */
export async function DeleteSavedView(
  project_id: string,
  view_id: string,
  options?: RequestOptions
): Promise<Response> {
  const client = getApiClient();
  let requestPath = `${BASE_PATH}/projects/:project_id/views/:view_id`;
  requestPath = requestPath.replace(':project_id', encodeURIComponent(project_id));
  requestPath = requestPath.replace(':view_id', encodeURIComponent(view_id));
  const requestOptions = options;
  return client.delete<Response>(requestPath, requestOptions);
}
